<sbpro-layout-dashboard [light]="true">
    <!-- ADM-827: alerta de pocos números de control; solo se muestra bajo /pos. -->
    <fina-control-numbers-alert-banner></fina-control-numbers-alert-banner>
    <router-outlet></router-outlet>
</sbpro-layout-dashboard>
